import { asCurrency, asDate, asTimelessDate, CollapsableSection, Column, Columns, FormInput } from "lqx-react";
import * as React from "react";
import { IncomingRemitanceAdviceActivity } from "api/activity";
import { RemittanceDocumentLink } from "./remittanceDocumentLink";

export const IncomingRemitanceAdviceDetails = ({data, currency} : {
    data : IncomingRemitanceAdviceActivity,
    currency: string,
}) => {
    return (
        <>
        <CollapsableSection title="Remittance Details:">
            <Columns>
                <Column>
                    <FormInput label="Remittance Amount" value={asCurrency(data.remittanceDetails.amount, currency)} />
                    <FormInput label="Value Date" value={asTimelessDate(data.remittanceDetails.valueDate)} />
                </Column>
                <Column>
                    <FormInput label="Statement Date" value={asTimelessDate(data.remittanceDetails.statementDate)} />
                    <RemittanceDocumentLink remittanceDocument={data.remittanceDetails.remittanceDocument} />
                </Column>
            </Columns>
        </CollapsableSection>
        <CollapsableSection title="Customer Details:">
            <Columns>
                <Column>
                    <FormInput label="Customer Name" value={data.relationshipDetails.customerName} />
                </Column>
            </Columns>
        </CollapsableSection>
        <CollapsableSection title="Supplier Details:">
            <Columns>
                <Column>
                    <FormInput label="Legal Entity Name" value={data.relationshipDetails.supplierLegalEntityName} />
                </Column>
                <Column>
                    <FormInput label="Company Code" value={data.relationshipDetails.supplierCompanyCode} />
                </Column>   
            </Columns>
        </CollapsableSection>
        </>
    );
}
